import React from "react";
import PropTypes from "prop-types";
import move from "lodash-move";
import SortableList from "./SortableList";
import {FieldContext} from "@morningtrain/react-fields";

function RepeaterItemsWrapper(props) {

    const field = React.useContext(FieldContext);
    const {items} = props;

    const moveItem = (fromIndex, toIndex) => {

        if (typeof fromIndex === 'undefined' || typeof toIndex === 'undefined') {
            return;
        }

        let temp = [...items];
        let newList = move(temp, fromIndex, toIndex);
        items.replace(newList);

    }

    let wrapper = null;

    if (field.draggable === false) {
        return (
            <div className={'repeater-field-items-wrapper'}>
                {props.children}
            </div>
        );
    }

    return (
        <div ref={ref => wrapper = ref} className={'repeater-field-items-wrapper'}>
            <SortableList useDragHandle={true}
                          useWindowAsScrollContainer={false}
                          transitionDuration={300}
                          shouldCancelStart={() => undefined}
                          lockOffset={0}
                          lockToContainerEdges={false}
                          lockAxis={'y'}
                          helperContainer={() => {
                              return wrapper;
                          }}
                          helperClass={'repeater-field-sortable-helper'}
                          onSortEnd={({oldIndex, newIndex}) => {
                              moveItem(oldIndex, newIndex);
                          }}
            >
                {props.children}
            </SortableList>
        </div>
    );

}

RepeaterItemsWrapper.defaultProps = {
    items: [],
    name: null
};

RepeaterItemsWrapper.propTypes = {
    items: PropTypes.any,
    name: PropTypes.string.isRequired
};

export default RepeaterItemsWrapper;
